module.exports = __webpack_public_path__ + "static/media/ic_operator_orange.d14df61f.svg";